import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { UCCFilingData } from "../domain/models/ucc-filing.model";
import { ConfigService } from "../../../../lib/config/config.service";
import { MessageService } from "../../../message/message.service";
import { catchError } from "rxjs/operators";
import { ResourceService } from "../../../../lib/resource/resource.service";

@Injectable({
  providedIn: "root",
})
export class EntityAPIEntityUCCFilingRemote {
  private readonly baseUrl: string;
  private readonly documentsBaseUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly messageService: MessageService,
    private readonly resourceService: ResourceService
  ) {
    this.baseUrl = `${this.configService.environment.entityAPI.url}/ucc-filings`;
    this.documentsBaseUrl = `${this.configService.environment.entityAPI?.url}/ucc-filing-files`;
  }

  initializeUCC1(entityId: number): Observable<UCCFilingData> {
    return this.http
      .post<UCCFilingData>(`${this.baseUrl}/initialize`, { entityId })
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  refreshUCC1(entityId: number): Observable<UCCFilingData> {
    return this.http
      .post<UCCFilingData>(`${this.baseUrl}/refresh`, { entityId })
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  downloadDocument(fileId: number): Observable<void> {
    return this.resourceService.download({url: `${this.documentsBaseUrl}/${fileId}`});
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    switch (error.status) {
      case 400:
      case 404:
      case 422:
        this.messageService.error(error);
        break;
      case 401:
        console.warn("Unauthorized access - should be handled by interceptor");
        break;
      case 500:
        this.messageService.error(
          "Internal server error occurred. Please try again later.",
        );
        break;
      default:
        this.messageService.error(
          "An unexpected error occurred. Please try again later.",
        );
        break;
    }

    return EMPTY;
  }
}
